import { JetView } from "webix-jet"; // Importing JetView class from Webix Jet framework
import { devConfig } from "config/config"; // Importing application configuration file

/**
 * Class representing the TableWatchListReportView.
 * Handles both detailed and summarized Watch List report data in datatables.
 */
export default class TableWatchListReportView extends JetView { // Exporting a class that extends JetView to create a report table view
    config() { // Method defining the UI layout configuration
        const _ = this.app.getService("locale")._; // Getting localization service for translations

        return { // Returning the main UI structure
            rows: [ // Layout divided into vertical rows
                {
                    id: "preloader", // Container ID for the datatables
                    cols: [ // Child components arranged horizontally
                        {
                            view: "datatable", // Webix datatable component for detailed view
                            id: "datatable", // Unique ID for the detailed datatable
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for table borders
                            select: true, // Enables row selection
                            scrollY: true, // Enables vertical scrolling
                            columns: [ // Definition of columns for detailed data
                                {
                                    id: "ValidationId", // Column ID for validation identifier
                                    header: _("ID Validación"), // Localized column header
                                    width: 130, // Column width
                                    sort: "int" // Enables numeric sorting
                                },
                                {
                                    id: "UserId", // Column ID for user identifier
                                    header: _("ID Usuario"), // Localized column header
                                    width: 130, // Column width
                                    sort: "int" // Numeric sorting
                                },
                                {
                                    id: "ValidationDate", // Column ID for validation date
                                    header: _("Fecha Validación"), // Localized column header
                                    width: 200, // Column width
                                    sort: "string" // Sort by string value
                                },
                                {
                                    id: "Result", // Column ID for result
                                    header: _("Resultado"), // Localized column header
                                    width: 160 // Column width
                                },
                                {
                                    id: "List", // Column ID for list type
                                    header: _("Lista"), // Localized column header
                                    width: 200 // Column width
                                },
                                {
                                    id: "Score", // Column ID for score value
                                    header: _("Score"), // Localized column header
                                    width: 120 // Column width
                                },
                                {
                                    id: "UserName", // Column ID for username
                                    header: _("Nombre de Usuario"), // Localized column header
                                    fillspace: true // Expands column to fill available space
                                },
                            ],
                            loadahead: devConfig.getDefaultDataFetch(), // Defines number of records to preload from config
                            pager: "pagerA", // Links datatable to pager component
                            tooltip: true, // Enables tooltips on hover
                        },
                        {
                            view: "datatable", // Second datatable for summarized data
                            id: "datatable2", // Unique ID for summary table
                            css: "webix_header_border webix_data_border webix_footer_border", // Same border styling
                            hidden: true, // Initially hidden until summary view is selected
                            select: true, // Enables selection
                            scrollY: true, // Enables vertical scrolling
                            columns: [ // Columns for summarized data
                                {
                                    id: "Date", // Column ID for date
                                    header: _("Fecha"), // Localized header
                                    width: 200 // Column width
                                },
                                {
                                    id: "TotalValidations", // Column ID for total validations
                                    header: _("Total Validaciones"), // Localized header
                                    width: 200 // Column width
                                },
                                {
                                    id: "Coincidences", // Column ID for coincidences
                                    header: _("Coincidencias"), // Localized header
                                    width: 200 // Column width
                                },
                                {
                                    id: "NoCoincidences", // Column ID for no coincidences
                                    header: _("Sin Coincidencias"), // Localized header
                                    width: 200 // Column width
                                },
                            ],
                            loadahead: devConfig.getDefaultDataFetch(), // Preload amount from config
                            pager: "pagerA", // Links table to the same pager
                            tooltip: true, // Enables tooltips
                        },
                    ],
                },
            ],
        };
    }

    init() { // Method executed after component initialization
        const urlDetails = devConfig.geturlApi() + "UserManagement/WatchListReportDetails"; // API endpoint for detailed report data
        const urlSummary = devConfig.geturlApi() + "UserManagement/WatchListReport"; // API endpoint for summarized report data
        const vthis = this; // Reference to current class instance

        // Event listener for when filter data is submitted
        this.on(this.app, "requests:filter", (filterData) => {
            let query = ""; // String to build query parameters

            // Add date filters to query if provided
            if (filterData.validationDateFrom && filterData.validationDateTo) {
                query += `&validationDateFrom=${filterData.validationDateFrom}`; // Start date
                query += `&validationDateTo=${filterData.validationDateTo}`; // End date
            }

            // Add other filters dynamically if they exist
            if (filterData.result) query += `&result=${filterData.result}`; // Result filter
            if (filterData.documentNumber) query += `&documentNumber=${filterData.documentNumber}`; // Document number filter
            if (filterData.userId) query += `&userId=${filterData.userId}`; // User ID filter

            // Determine which datatable to display based on selected view type
            if (filterData.Overall == 1) { // If summarized view selected
                $$("datatable").hide(); // Hide detailed datatable
                $$("datatable2").show(); // Show summarized datatable
                $$("datatable2").clearAll(); // Clear previous data
                $$("datatable2").load(`${urlSummary}?start=0&count=10${query}`); // Load new data from API
            } else { // If detailed view selected
                $$("datatable2").hide(); // Hide summarized datatable
                $$("datatable").show(); // Show detailed datatable
                $$("datatable").clearAll(); // Clear existing data
                $$("datatable").load(`${urlDetails}?start=0&count=10${query}`); // Load detailed data from API
            }
        });
    }
}
